import * as Application from "expo-application";
// import * as SecureStore from "expo-secure-store";
import { getItem, saveItem, deleteItem } from "../utils/secureStorage";
import { axiosWithCredentials } from "../api/axios";

/**
 * Generates a persistent device ID using Android ANDROID_ID (or fallback)
 *
 * - On Android: uses ANDROID_ID (stable across reinstalls unless factory reset)
 * - On iOS: falls back to a securely stored UUID
 */
export const getPersistentDeviceId = async (usernameOrEmail) => {
  try {
    // Fetch user info from backend to get userId
    const res = await axiosWithCredentials.post("/getUserByIdentifier/getUserByIdentifier", {
      usernameOrEmail,
    });
    // Example backend route: checks if input matches username or email and returns userId
    const userId = res?.data?.userId;

    if (!userId) {
      //console.error("User not found for:", usernameOrEmail);
      return null;
    }

    // Check if we already have a stored ID for this userId
    // const existingId = await SecureStore.getItemAsync(`persistentDeviceId_${userId}`);
    const existingId = await getItem(`persistentDeviceId_${userId}`);

    if (existingId) {
      //console.log("Existing device ID found for user:", userId);
      return existingId;
    }

    //console.log("No device ID found, generating new one...");

    // Get the Android ID (async)
    let uniqueId = null;

    const androidId = Application.getAndroidId();
    if (androidId) {
      uniqueId = androidId; // ANDROID_ID (stable across reinstalls)

      //console.log("theID", uniqueId);
    } else {
      // fallback for iOS or rare Android cases
      //console.log("fall back");
      uniqueId = `${Application.applicationId}_${Math.random().toString(36).substring(2, 10)}`;
    }

    // Save it securely
    //await SecureStore.setItemAsync(`persistentDeviceId_${userId}`, uniqueId);
    await saveItem(`persistentDeviceId_${userId}`, uniqueId);

    return uniqueId;
  } catch (err) {
    //console.error("Error generating persistent device ID:", err);
    return null;
  }
};
